/**
 * 写真のアップロードコンポーネント
 */
/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { css } from "@emotion/react";

import ConfirmImage from "./ConfirmImage";

const uploadedPhoto = memo(({ uploadImgSmall }) => {
  const imgArrary = [uploadImgSmall];
  return (
    <span css={imgFlex}>
      {imgArrary.map((imgNumber, index) => (
        <ConfirmImage key={index} src={imgNumber} />
      ))}
    </span>
  );
});

const imgFlex = css`
  display: flex;
  justify-content: space-evenly;
  width: 30%;
`;

export default uploadedPhoto;
